/**
 * orga-app-api - veranstaltungen-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DokumentHinzufuegenRequest { 
    dokument_upload_id?: string;
    titel: string;
    beschreibung?: string;
    dateiname?: string;
    ist_oeffentlich?: boolean;
    gruppierung?: string;
    dokument_id: string;
    veranstaltung_id: string;
}

